<div class="password-validation">
  <p *ngFor="let error of errors" [ngClass]="validator(error.label)">
    <mat-icon class="icon-center-green" [ngClass]="validator(error.label)" *ngIf="hasError(error.label); else dash">
      check_circle_outline
    </mat-icon>
    <ng-template #dash>
      <mat-icon class="icon-center">check_circle_outline</mat-icon>
    </ng-template>
    {{ error.content }}
  </p>
</div>
